import { BusinessCategory, PaginatedResponse } from '../types';
import apiService from './api';

export class BusinessCategoryService {
  async getAllCategories(
    page: number = 0,
    size: number = 10,
    sort?: string,
    filters?: any
  ): Promise<PaginatedResponse<BusinessCategory>> {
    return apiService.getPaginated<BusinessCategory>(
      '/api/business-categories',
      page,
      size,
      sort,
      filters
    );
  }

  async getAllCategoriesAdmin(activeOnly: boolean = false): Promise<BusinessCategory[]> {
    return apiService.get<BusinessCategory[]>(`/api/business-categories?activeOnly=false`);
  }

  async getCategoryById(id: number): Promise<BusinessCategory> {
    return apiService.get<BusinessCategory>(`/api/business-categories/${id}`);
  }

  async getCategoryByCode(code: string): Promise<BusinessCategory> {
    return apiService.get<BusinessCategory>(`/api/business-categories/code/${code}`);
  }

  async createCategory(categoryData: Partial<BusinessCategory>): Promise<BusinessCategory> {
    return apiService.post<BusinessCategory>('/api/business-categories', categoryData);
  }

  async updateCategory(
    id: number,
    categoryData: Partial<BusinessCategory>
  ): Promise<BusinessCategory> {
    return apiService.put<BusinessCategory>(`/api/business-categories/${id}`, categoryData);
  }

  async deleteCategory(id: number): Promise<void> {
    await apiService.delete(`/api/business-categories/${id}`);
  }

  async activateCategory(id: number): Promise<void> {
    await apiService.put(`/api/business-categories/${id}/activate`, {});
  }

  async deactivateCategory(id: number): Promise<void> {
    await apiService.put(`/api/business-categories/${id}/deactivate`, {});
  }

  async getActiveCategories(): Promise<BusinessCategory[]> {
    return apiService.get<BusinessCategory[]>('/api/business-categories');
  }
}

export const businessCategoryService = new BusinessCategoryService();
export default businessCategoryService;
